import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { DocumentFile } from '../../../../models/document-file';
import { DocumentParsingStep } from '../../../../models/review-queue-item';
import { Router } from '@angular/router';

@Component({
    selector: 'app-processing-item',
    templateUrl: './processing-item.component.html',
    styleUrls: ['./processing-item.component.scss'],
    standalone: false
})
export class ProcessingItemComponent {
  @Input() reviewId: String;
  @Input() file: DocumentFile;
  @Input() steps: Array<DocumentParsingStep>;
  @Input() fileSuffix: String;
  subsArr$: Subscription[] = [];
  titleStatus = '';
  readyForReview = false;

  constructor(
    private _router: Router
  ) { }

  routeToReview() {
    this._router.navigate(['/review/' + this.reviewId]);
  }

  getReviewStep() {
    this.titleStatus = 'Your document is being processed.';
    if (!this.steps) {
      return;
    }

    const i = this.steps.findIndex(s => s.showReview);
    if (i >= 0) {
      const step = this.steps[i];
      if (step.status === 'active') {
        this.titleStatus = 'Your document is ready for your review';
        this.readyForReview = true;
      }
    }

    return this.titleStatus;
  }
}
